import { Typography } from "antd";
import styled from "styled-components";

export const StyledProductItem = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 0 4px;
    gap: 6px;
    justify-content: space-between;
`;

export const StyledProductItemWrapper = styled.div`
    padding: 16px 0;
    border-bottom: 1px solid #313131;
`;

export const StyledProductInfoText = styled(Typography)`
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    color: #5f5f5f;
`;

export const StyledProductBarcode = styled(Typography)`
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    color: #5f5f5f;
    border-bottom: 1px dashed #5f5f5f;
`;

export const StyledRemainingCount = styled.span<{ $isInfinity?: boolean }>`
    color: ${({ theme }) => theme.additionalTypographyColor};

    ${({ $isInfinity }) => $isInfinity && "font-size: 20px;"}
`;
